// extracted by mini-css-extract-plugin
export default {"signBtn":"SignInButton_signBtn__j8rOl"};